import { SubClauseWithReference } from "../ars_ldm";
import { isLevelOrder } from "./isLevelOrder";

/**
 * Type guard to check if a value is a SubClauseWithReference.
 *
 * @param obj - The value to check
 * @returns True if the value is a SubClauseWithReference
 */
export const isSubClauseWithReference = (obj: unknown): obj is SubClauseWithReference => {
  // Check basic structure
  if (!isLevelOrder(obj)) return false;

  const chkObj = obj as {
    id?: unknown;
    subClauseId?: unknown;
    condition?: unknown;
    compoundExpression?: unknown;
  };

  // Check id is a non-blank string
  if (typeof chkObj.id !== "string" || chkObj.id === "") return false;

  // Check subClauseId is a non-blank string
  if (typeof chkObj.subClauseId !== "string" || chkObj.subClauseId === "") return false;

  // Must not have condition property
  if (chkObj.condition !== undefined) return false;

  // Must not have compoundExpression property
  if (chkObj.compoundExpression !== undefined) return false;

  return true;
};
